import { PageHero } from "@/components/site/PageHero";
import { AboutSplit } from "@/components/site/AboutSplit";
import { WhyUs } from "@/components/site/WhyUs";
import { Eyebrow, FadeUp } from "@/components/site/Reveal";
import { IMG } from "@/data/content";

const VALUES = [
  ["Clinicians first", "Bookings are made by people who have worked the shift themselves."],
  ["Consistency", "Small, stable teams so wards and families see familiar faces."],
  ["Candour", "If we can't fill a shift safely, we say so — early."],
  ["Dignity", "Care that protects privacy, choice and independence."],
];

export default function About() {
  return (
    <div data-testid="page-view-about">
      <PageHero testId="about-hero" eyebrow="About us" lines={["Local people.", <>National <span className="font-serif-i font-normal tracking-normal text-sky-300">standards.</span></>]}
        intro="An East Midlands nursing agency built around the people who deliver care — and the people who receive it." />
      <AboutSplit />
      <section className="bg-[#F8FAFC] py-24 md:py-32" data-testid="values-section">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <Eyebrow>What we stand for</Eyebrow>
            <div className="mt-8 aspect-square overflow-hidden rounded-full max-w-xs"><img src={IMG.scrubs} alt="Carer with resident" className="h-full w-full object-cover" /></div>
          </div>
          <div className="lg:col-span-8 grid sm:grid-cols-2 gap-x-10">
            {VALUES.map(([t, d], i) => (
              <FadeUp key={t} delay={i * 0.06} className="py-8 border-t border-slate-300" data-testid={`value-${i}`}>
                <span className="font-mono-x text-sm text-sky-700">0{i + 1}</span>
                <h3 className="mt-3 text-2xl md:text-3xl font-bold tracking-tight text-[#0A192F]">{t}</h3>
                <p className="mt-3 text-slate-600 leading-relaxed">{d}</p>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>
      <WhyUs />
    </div>
  );
}
